import { Input as InputChakraUI, type InputProps } from '@chakra-ui/react'

const Input = (props: InputProps) => {
  return <InputChakraUI borderColor="gray.300" {...props} />
}

export default Input
